import { render } from "./UserSignUpNotice.vue?vue&type=template&id=f9576f30"
import script from "./UserSignUpNotice.vue?vue&type=script&lang=js"
export * from "./UserSignUpNotice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__